exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo {\r\n  line-height: 70px;\r\n}\r\n\r\n.logo,\r\n.logo-mini,\r\n.logo-lg {\r\n  min-height: 70px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/header/header.component.css
// module id = ../../../../../src/app/main/header/header.component.css
// module chunks = main